import Glide from '@glidejs/glide';


export const homePageSlider = () => {
    let glideElms = document.querySelectorAll('.glide');
    if (glideElms.length) {
        let sliderGlider = new Glide('.glide',
            {
                type: 'carousel',
                startAt: 0,
                perView: 3.5,
                // perView: 3,
                // rewind: true,
                touchRatio: .8,
                perTouch: 1,
                direction: 'ltr',
                gap: 10,
                breakpoints: {
                    1200: { // At 1200px and below
                        perView: 2
                    },
                    768: { // At 768px and below
                        perView: 1
                    }
                }
            }
        )
        sliderGlider.mount();
    }
}